import { PathFactory } from "./../../../environment/factories/PathFactory";
import { IBasePathProvider } from "./../../../environment/providers/IBasePathProvider";
import { EnvironmentProvider } from "./EnvironmentProvider";
import { ConcreteEnvironmentData } from "../data/ConcreteEnvironmentData";
import { ConcreteEnvironmentPatterns } from "../patterns/ConcreteEnvironmentPatterns";
import { getLogger } from "@goodgamestudios/logger";
const logger = getLogger("CoreJS.PathProvider");

export class PathProvider implements IBasePathProvider {
    public static ERROR_LOCKED: string = "The class is a singleton, please use PathProvider.instance instead.";

    protected static _locked: boolean = true;
    private static _instance: PathProvider;

    public static get instance(): PathProvider {
        if (!PathProvider._instance) {
            PathProvider._locked = false;
            PathProvider._instance = new PathProvider();
            PathProvider._locked = true;
        }

        return PathProvider._instance;
    }

    private _pathFactory: PathFactory;
    private _data: ConcreteEnvironmentData;
    private _itemVersions: any;
    private _interfaceVersions: any;

    constructor() {
        if (PathProvider._locked) {
            throw new Error(PathProvider.ERROR_LOCKED);
        }

        this._pathFactory = new PathFactory();
        this._data = new ConcreteEnvironmentData();
    }

    public get networkConfigURL(): string {
        return this._pathFactory.build(this.patterns.networkConfigPathPattern, this.data);
    }

    public get countryConfigURL(): string {
        return this._pathFactory.build(this.patterns.countryConfigPathPattern, this.data);
    }

    public get zoneCapacitiesConfigURL(): string {
        return this._pathFactory.build(this.patterns.zoneCapacitiesConfigPathPattern, this.data);
    }

    public get maintenanceConfigURL(): string {
        return this._pathFactory.build(this.patterns.maintenanceConfigPathPattern, this.data);
    }

    public get branchesConfigURL(): string {
        return this._pathFactory.build(this.patterns.branchesConfigPathPattern, this.data);
    }

    public get languageConfigURL(): string {
        logger.debug("current Environment ", EnvironmentProvider.instance.current);
        logger.debug("GET LANGUAGE CONFIG PATTERN ", this.patterns.languageConfigPathPattern);
        logger.debug("GET LANGUAGE CONFIG DATA", this.data);
        var languageXMLPath = this._pathFactory.build(this.patterns.languageConfigPathPattern, this.data);
        return languageXMLPath;
        //  var languageJSONPath = languageXMLPath.replace(".xml", ".json")//.replace(".ggs", ".json");
        //return languageJSONPath;
    }

    public get cldrConfigURL(): string {
        logger.debug("current Environment ", EnvironmentProvider.instance.current);
        logger.debug("CLDR base URL ", this.patterns.cldrConfigPathPattern);
        return this._pathFactory.build(this.patterns.cldrConfigPathPattern, this.data)
    }

    public get fontsURL(): string {
        let pattern: string;
        logger.debug("fontsURL --> using VersionedFontSWF", this.data.globals.useVersionedFontSWF);
        if (this.data.globals.useVersionedFontSWF) {
            pattern = this.patterns.fontsSWFURLPatternVersioned;
        }
        else {
            pattern = this.patterns.fontsSWFURLPattern;
        }
        return this._pathFactory.build(pattern, this.data);
    }

    public get dataCookieURL(): string {
        return this._pathFactory.build(this.patterns.dataCookiePathPattern, this.data);
    }

    public get accountCookieURL(): string {
        return this._pathFactory.build(this.patterns.accountCookiePathPattern, this.data);
    }

    public get networkCookieURL(): string {
        return this._pathFactory.build(this.patterns.networkCookiePathPattern, this.data);
    }

    public get versionURL(): string {
        return this._pathFactory.build(this.patterns.versionPathPattern, this.data);
    }

    public get itemsVersionURL(): string {
        return this._pathFactory.build(this.patterns.itemsVersionPathPattern, this.data);
    }

    public getItemSWFURL(i: number): string {
        let result: string = this.patterns.itemSWFURLPattern;
        result = result.replace("{itemIndex}", i.toString());
        result = result.replace("{itemVersion}", Object(this._data.globals)["versionNumberItemLib" + i]);
        result = this._pathFactory.build(result, this.data);

        return result;
    }

    public get gameURL(): string {
        return this._pathFactory.build(this.patterns.gamePathPattern, this.data);
    }

    public get assetsFolderURL(): string {
        return this._pathFactory.build(this.patterns.assetsFolderPathPattern, this.data);
    }

    public getAssetURL(name: string): string {
        return this.assetsFolderURL + this._itemVersions.getPath(name);
    }

    public getInterfaceAssetURL(name: string): string {
        return this.assetsFolderURL + this._interfaceVersions.getPath(name);
    }

    public get itemsXMLURL(): string {
        return this._pathFactory.build(this.patterns.itemXMLURLPattern, this.data);
    }

    public get audiosFolderURL(): string {
        return this._pathFactory.build(this.patterns.audiosFolderPathPattern, this.data);
    }

    public getSoundURL(name: string): string {
        return this.audiosFolderURL + name;
    }

    public get patterns(): ConcreteEnvironmentPatterns {
        return EnvironmentProvider.instance.current.patterns;
    }

    public get data(): ConcreteEnvironmentData {
        return EnvironmentProvider.instance.current.data;
    }

    public set itemVersions(value: any) {
        this._itemVersions = value;
    }

    public get itemVersions(): any {
        return this._itemVersions;
    }

    public set interfaceVersions(value: any) {
        this._interfaceVersions = value;
    }

    public get interfaceVersions(): any {
        return this._interfaceVersions;
    }

    public get abTestConfigURL(): string {
        return this._pathFactory.build(this.patterns.abTestConfigPathPattern, this.data);
    }

    public get abTestTrackURL(): string {
        return this._pathFactory.build(this.patterns.abTestTrackPathPattern, this.data);
    }

    public get abTestDisplayURL(): string {
        return this._pathFactory.build(this.patterns.abTestDisplayPathPattern, this.data);
    }

    public get shopURL(): string {
        return this._pathFactory.build(this.patterns.shopPathPattern, this.data);
    }
}
